import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getFirstTwoLetters = (name: string): string => {
  return name.slice(0, 2).toUpperCase();
};

export const trackPath = () => {
  if (typeof window === "undefined") return;

  const pathname = window.location.pathname;
  const search = window.location.search;

  const fullPath = pathname + search;

  sessionStorage.setItem("aichat-previousPath", fullPath);
};

export const getPreviousPath = () => {
  return sessionStorage.getItem("aichat-previousPath");
};

export const getErrorFileAttachmentMessage = (file: File) => {
  const fileName = file.name.toLowerCase();
  const fileExt = fileName.slice(fileName.lastIndexOf("."));
  return `File type ${fileExt} is not supported. We only support images, video and docs`;
};

export function getTypeFromFileType(fileType: string) {
  if (fileType.startsWith("image")) return "image";
  if (fileType.startsWith("video")) return "video";
  if (fileType.startsWith("audio")) return "audio";
  return "file";
}
